const TELEGRAM_WIDGET_ORIGIN = "https://oauth.telegram.org";
const TELEGRAM_WIDGET_SCRIPT_URL =
  "https://oauth.telegram.org/js/telegram-login.js?4";
const TELEGRAM_CLIENT_ID = "8763261185";

let didWarmTelegramWidget = false;
let telegramWidgetHost = null;
let telegramWidgetLoaded = false;
let telegramWidgetLoadListeners = [];
let telegramParkingNode = null;

const appendHeadNodeOnce = (selector, createNode) => {
  if (document.head.querySelector(selector)) {
    return;
  }

  document.head.appendChild(createNode());
};

export const warmTelegramWidgetAssets = () => {
  if (didWarmTelegramWidget || typeof document === "undefined") {
    return;
  }

  didWarmTelegramWidget = true;

  appendHeadNodeOnce(
    `link[rel="preconnect"][href="${TELEGRAM_WIDGET_ORIGIN}"]`,
    () => {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = TELEGRAM_WIDGET_ORIGIN;
      link.crossOrigin = "anonymous";
      return link;
    },
  );

  appendHeadNodeOnce(
    `link[rel="dns-prefetch"][href="${TELEGRAM_WIDGET_ORIGIN}"]`,
    () => {
      const link = document.createElement("link");
      link.rel = "dns-prefetch";
      link.href = TELEGRAM_WIDGET_ORIGIN;
      return link;
    },
  );
};

const notifyTelegramWidgetLoaded = () => {
  telegramWidgetLoaded = true;
  telegramWidgetLoadListeners.forEach((listener) => listener());
  telegramWidgetLoadListeners = [];
};

export const getTelegramParkingNode = () => {
  if (telegramParkingNode || typeof document === "undefined") {
    return telegramParkingNode;
  }

  telegramParkingNode = document.createElement("div");
  telegramParkingNode.setAttribute("data-telegram-widget-parking", "true");
  telegramParkingNode.style.position = "absolute";
  telegramParkingNode.style.width = "0";
  telegramParkingNode.style.height = "0";
  telegramParkingNode.style.overflow = "hidden";
  telegramParkingNode.style.pointerEvents = "none";
  telegramParkingNode.style.opacity = "0";
  document.body.appendChild(telegramParkingNode);

  return telegramParkingNode;
};

export const ensureTelegramWidgetHost = (onLoad) => {
  if (typeof document === "undefined") {
    return null;
  }

  warmTelegramWidgetAssets();

  if (onLoad) {
    if (telegramWidgetLoaded) {
      onLoad();
    } else {
      telegramWidgetLoadListeners.push(onLoad);
    }
  }

  if (telegramWidgetHost) {
    return telegramWidgetHost;
  }

  telegramWidgetHost = document.createElement("div");
  telegramWidgetHost.style.width = "100%";

  const script = document.createElement("script");
  script.async = true;
  script.src = TELEGRAM_WIDGET_SCRIPT_URL;
  script.setAttribute("data-client-id", TELEGRAM_CLIENT_ID);
  script.setAttribute("data-onauth", "onTelegramAuth(data)");
  script.onload = notifyTelegramWidgetLoaded;

  telegramWidgetHost.appendChild(script);
  getTelegramParkingNode()?.appendChild(telegramWidgetHost);

  return telegramWidgetHost;
};

export const parkTelegramWidgetHost = () => {
  const parkingNode = getTelegramParkingNode();
  if (parkingNode && telegramWidgetHost) {
    parkingNode.appendChild(telegramWidgetHost);
  }
};

export const isTelegramWidgetLoaded = () => telegramWidgetLoaded;

export { TELEGRAM_WIDGET_SCRIPT_URL };
